module.exports = __webpack_public_path__ + "img/U1F42D.1256ffbb.png";